import React from 'react';
import styles from './Card.module.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  alert?: boolean;
  error?: boolean;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hoverable = true,
  alert = false,
  error = false,
  onClick,
}) => {
  const classNames = [
    styles.card,
    hoverable ? styles.hoverable : '',
    alert ? styles.alert : '',
    error ? styles.error : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} onClick={onClick}>
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, icon }) => {
  // If children is a single React element or text, wrap it in header text div
  // If it's multiple elements or already structured, render as is
  const isSimpleContent = React.Children.count(children) === 1 && 
    (typeof children === 'string' || React.isValidElement(children));
  
  return (
    <div className={styles.cardHeader}>
      {icon && <div className={styles.cardIcon}>{icon}</div>}
      {isSimpleContent ? (
        <div className={styles.cardHeaderText}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
};

interface CardTitleProps {
  children: React.ReactNode;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children }) => {
  return <h3 className={styles.cardTitle}>{children}</h3>;
};

interface CardSubtitleProps {
  children: React.ReactNode;
}

export const CardSubtitle: React.FC<CardSubtitleProps> = ({ children }) => {
  return <p className={styles.cardSubtitle}>{children}</p>;
};

interface CardContentProps {
  children: React.ReactNode;
}

export const CardContent: React.FC<CardContentProps> = ({ children }) => {
  return <div className={styles.cardContent}>{children}</div>;
};

interface CardActionsProps {
  children: React.ReactNode;
}

export const CardActions: React.FC<CardActionsProps> = ({ children }) => {
  return <div className={styles.cardActions}>{children}</div>;
};